export default {
  ridership: {
    title: 'Ridership Dashboard',
    ridershipByRoute: 'Ridership by Route',
    ridershipByStop: 'Ridership by Stop',
    byRun: 'by Run',
    byDayOfWeek: 'by Day of the Week',
    byDate: 'by Date',
    byTimeOfDay: 'by Time of Day',
    byWeekday: 'by Weekday',
    byFirstStopDeparture: 'by First Stop Departure',
    byLastStopArrival: 'by Last Stop Arrival',
    allTripsArriving: 'All trips arriving between',
    allTripsDeparting: 'All trips departing between',
    allTripsArrivingDeparting: 'All trips arriving/departing between',
    allDepartures: 'All departures between',
    allArrivals: 'All arrivals between',
    loadFactor: 'Load Factor',
    totalRidership: 'Total Ridership',
    vehicleOccupancy: 'Vehicle Occupancy',
    total: 'Total',
    allRoutes: 'All Routes',
    moreRoutes: '+{0} more',
    noRoutesInRouteGroups: 'No routes in the selected route groups',
    allStops: 'All Stops',
    selectStop: 'Select Stop',
    allDirections: 'All',
    inbound: 'Inbound',
    outbound: 'Outbound',
    loop: 'Loop',
    direction: 'Direction',
    route: 'Route',
    stop: 'Stop',
    riders: 'Riders',
    numRiders: '# Riders',
    totalOn: 'On',
    totalOff: 'Off',
    sum: 'Sum',
    on: 'On',
    off: 'Off',
    sortBy: 'Sort by',
    ascending: 'ascending',
    descending: 'descending',
    legendForRouteColors: 'Legend for Route Colors',
    noData: 'No data available for the selected filters',
    loading: 'Loading...',
    exportExcel: 'Export Excel',
    timeOfDay: 'Time of Day',
    dayOfWeek: 'Day of the Week',
    date: 'Date',
    scheduled: 'Scheduled',
    actual: 'Actual',
    period: 'Period',
    referenceTime: 'Reference Time',
    fromTime: 'From',
    toTime: 'To',
    viewMore: 'View {count} more stops',
    viewLess: 'View less',
    interval: 'Interval',
    interval15Min: '15 min',
    interval30Min: '30 min',
    interval1Hour: '1 h',
    departureTimeGroupedBy: 'Departure Time (Grouped by {interval} intervals)',
    arrivalTimeGroupedBy: 'Arrival Time (Grouped by {interval} intervals)',
    intervalSuffix15Min: '15-min',
    intervalSuffix30Min: '30-min',
    intervalSuffix1Hour: '1-hour',
    departureTimeExact: 'Departure time (Showing exact departure times)',
    arrivalTimeExact: 'Arrival time (Showing exact arrival times)',
    dayPlural: '{day}s',
    dep: 'Dep.',
    arr: 'Arr.',
    departures: 'departures',
    arrivals: 'arrivals',
  },
};
